/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_DevelopersInputs */

const en_mk_nav_developers = /** @type {(inputs: Mk_Nav_DevelopersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For developers`)
};

const id_mk_nav_developers = /** @type {(inputs: Mk_Nav_DevelopersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk developer`)
};

/**
* | output |
* | --- |
* | "For developers" |
*
* @param {Mk_Nav_DevelopersInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_developers = /** @type {((inputs?: Mk_Nav_DevelopersInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_DevelopersInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_developers(inputs)
	return en_mk_nav_developers(inputs)
});